import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TurnSlightLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"turn_slight_left"}/>
}
